<template>
  <div class="task-home-header">
        <div class="inner">
            <div class="tit-box">
                <h3>
                    <div v-html="$i18nUtil.trans('message.ProjectHeader.002','최근 업데이트 된 과제공간을 확인해보세요.협업한 보드는 OKR과 연결하여 관리해보세요.')"></div>
                </h3>
                <button type="button" class="btn-primary-medium white" v-if="isInternalUser" @click="addProject">{{ $i18nUtil.trans("button.project.add","과제 추가") }}</button>
                <div id="updateIcon" class="board-link">
                <a href="#" @click="goCooperationMemberBoard()">{{ $i18nUtil.trans("message.ProjectHeader.003","공유받은 비공개 보드 보기 {cnt}건", {cnt: totalElements > 999 ? '999+' : totalElements}) }}</a>
                <div class="droplayer icon info tip">
                    <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on">설명</v-btn>
                        </template>
                        <div class="dropdown-list">
                            <div class="tooltip-w tr">
                                <div>{{ $i18nUtil.trans("message.ProjectHeader.004","과제의 멤버가 아니더라도 비공개 보드를 공유받으면 협업할 수 있습니다.") }}</div>
                            </div>
                        </div>
                    </v-menu>
                </div>
                </div>
              </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import CreateProject from "@/components/cowork/general/project/modal/CreateProject";
export default {
    data() {
        return {
            tenantId: localStorage.getItem("tenantId"),
            totalElements: 0,
            updateTotalElements: 0,
            sortBy: ['lastUpdDate'],
            sortDesc: [true],
            groupKbnList: [],
        };
    },
    mounted(){
      this.getCooperationMemberBoardList();
      this.updateCooperationMemberBoardList();
    },
    computed : {
      ...mapState("introInfo", ["isInternalUser"]),
    },
    methods : {
      ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION", "COWORK_REST_ACTION"]),
      ...mapActions("modals", ["showModal"]),

      addProject() {
        const modalInfo = {
          title: this.$i18nUtil.trans("title.CreateProject.001","과제 등록"),
          width: "800px",
          height: "743px",
          obj: this.$modal,
          listType: this.listType,
          component: CreateProject
        };
        this.showModal(modalInfo);
      },
      goCooperationMemberBoard(){
        // localStorage.setItem("groupKbn", "PRO");
        this.$router.replace("/general/cooperationMemberBoard");
      },
      getCooperationMemberBoardList(){
      let obj = this;      
      let param = {
        url: '/api/copaper/paper/getCooperationMemberBoardList',
        method: 'post',
        req: {
          searchPaperTitle: "%%",
          limitRow: 20,
          page: 0,
          sortKey: obj.sortBy[0],
          sortDesc: obj.sortDesc[0],
          isPaperBookmarkChecked: obj.isBookmarkFilter,
          isPaperReadChecked: obj.isReadFilter,
          groupKbnList: obj.groupKbnList
        }
      };
      obj.COWORK_REST_ACTION(param)
        .then(function (res) {
          if(res.errorCode == null) {
            obj.totalElements += res.result.totalElements;
          }
        })
        .catch(function (err) {
          console.log(err);
        });
      },
      updateCooperationMemberBoardList(){
      let obj = this;      
      let param = {
        url: '/api/copaper/paper/getCooperationMemberBoardList',
        method: 'post',
        req: {
          searchPaperTitle: "%%",
          limitRow: 20,
          page: 0,
          sortKey: obj.sortBy[0],
          sortDesc: obj.sortDesc[0],
          isPaperBookmarkChecked: obj.isBookmarkFilter,
          isPaperReadChecked: true,
          groupKbnList: obj.groupKbnList
        }
      };
      obj.COWORK_REST_ACTION(param)
        .then(function (res) {
          if(res.errorCode == null) {
            obj.updateTotalElements += res.result.totalElements;
            if(obj.updateTotalElements > 0){
              document.getElementById('updateIcon').className = 'board-link new';
            }
          }
        })
        .catch(function (err) {
          console.log(err);
        });
      },
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/cowork/general/project/base/ProjectHeader.vue